export default "__VITE_ASSET__BGxyr3TH__"